export const decodeBase64Html = (
  encodedHtml: string | null | undefined
): string => {
  if (!encodedHtml) return '';

  try {
    return decodeURIComponent(escape(window.atob(encodedHtml)));
  } catch (error) {
    console.error('Failed to decode Base64 HTML:', error);
    return '';
  }
};

export const decodeBase64Img = (imgSrc?: string): Uint8Array | undefined => {
  if (!imgSrc) return;
  const base64Data = imgSrc.replace(/^data:image\/\w+;base64,/, '');
  return Uint8Array.from(atob(base64Data), (c) => c.charCodeAt(0));
};
